import React from 'react';

export const WordIcon = props => {
  return (
    <span
      className="solstice-icon- solstice-icon-word"
      style={{
        color: '#1971C2',
        ...props.style
      }}
    />
  );
};
